import React, { useState } from 'react';
import { Col, Row, Container, Button, Navbar, Nav } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { dcrActionCreators } from '../store/DCRStore';
import { schedulePaymentActionCreators } from '../store/SchedulePaymentStore';
import { historyActionCreators } from '../store/HistoryStore';
import { AppState } from '../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { DropDown } from './DropDown';
import { NavLink, useLocation } from 'react-router-dom';
import { Path } from '../App'
import { helperActionCreators } from '../store/HelperStore';
import { accountActionCreators } from '../store/AccountStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import logo from '../skin/images/Wespath_W.png';
import { AppDispatch } from '..';


type TCMHeaderProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const CMHeader = (props: TCMHeaderProps) => {
    const dispatch: AppDispatch = useDispatch();
    const { pathname } = useLocation();
    const isLoading = (props.dcr.isLoading && !props.dcr.isLoaded);
    const validPaths: string[] = [Path.ContributionCancelPayment, Path.ContributionDetails, Path.ContributionHistory, Path.ContributionSchedulePayment, Path.Default, Path.Logout, Path.ManageAccounts, Path.SSO, Path.ContactUs];
  
    function getSelectedInstitutionText(selectedInstitution: string) {
        let selectedInstitutionText: string | undefined = "";
        if (props.user?.institutions && selectedInstitution) {
            selectedInstitutionText = props.user?.institutions?.find(x => x.value === selectedInstitution)?.display;
        }
        else if (props.user?.institutions && !selectedInstitution) {
            selectedInstitutionText = props.user?.institutions[0].display;
        }
        return selectedInstitutionText ? `${selectedInstitutionText} (${selectedInstitution})` : "";
    }

    const [selectedInstitutionText, setSelectedInstitutionText] = useState(getSelectedInstitutionText(props.dcr?.selectedInstitution));


    const isInValidPath = () => {
        return !validPaths.includes(pathname);
    }

    const isLoggedOut = (pathname === Path.Logout || pathname === Path.SSO || pathname === Path.Default || isInValidPath());
    const isManageContributionTabActive = (pathname === Path.ContributionHistory || pathname === Path.ContributionDetails ||
        pathname === Path.ContributionSchedulePayment || pathname === Path.ContributionCancelPayment || pathname === Path.ContactUs)


    const getCurrentDate = () => {
        return ((new Date().getMonth() + 1).toString() + "/" + new Date().getDate().toString() + "/" + new Date().getFullYear().toString());
    }

    const onChangeInstitution = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const institution = e.target.value;
        props.requestCMHistory();
        await dispatch(dcrActionCreators.switchActiveInstitution(institution));
        props.fetchCMHistory(institution, false,false);
        props.resetAccountState();
        props.resetSchedulePaymentState();
       
        setSelectedInstitutionText(getSelectedInstitutionText(institution));
    }

      const DesktopNavBar = () => (
        <>
            <Navbar sticky="top" className="mb-0 p-0 mainNavBar desktop">
                <Nav className="justify-content-between w-100">
                    <Container className="ml-3 mr-0 px-0">
                        <Navbar.Brand className="d-inline-flex">
                            <NavLink style={{ textDecoration: "none" }} className="d-inline-flex" to={!isLoggedOut ? Path.ContributionHistory : Path.Logout}>
                                <div className="brandLogo d-none d-md-inline-block">
                                    <img src={logo} alt="Wespath Logo" />
                                </div>
                                <div className="brandText" >Contribution Management</div>
                            </NavLink>
                        </Navbar.Brand>


                        <Navbar.Text className="pr-2 d-inline-flex">
                            {pathname !== Path.Logout && <><><a className="pt-2 nav-link headerLinkText" rel="noreferrer noopener" href="http://www.wespath.org" target="_blank">wespath.org</a><span className="pt-2 headerLinkText">|</span></>
                                  <><a className="pt-2 nav-link headerLinkText" rel="noreferrer noopener" href="https://portal.wespath.org" target="_blank">Wespath Portal</a>{pathname !== Path.Logout && <span className="pt-2 headerLinkText">|</span>}</>
                            <> <a className="pt-2 nav-link headerLinkText" href="/contactus" target="_top">Contact Us</a>
                            <Button size="sm" onClick={() => props.logout()} variant="outline-secondary" id="btn-logout" className="btn-logout">Log Out</Button></></>}
                        </Navbar.Text>
                    </Container>
                </Nav>

            </Navbar>

            <div className="mt-1 mr-0 pr-0 pl-0 text-right">
                <UserInstitutions />
            </div>
        </>
    );

    const MobileNavBar = () => (
        <>
            <Row className="px-0">
                <Col className="col-12 col-md-12 px-xl-0 mb-4 mb-sm-0 custumNavBar">
                    {!isLoggedOut &&
                        <Navbar className="d-block d-lg-none pr-2 text-right mainNavBar" bg="#E6E7E9" expand="lg">
                            <Navbar.Brand style={{ float: "left", textDecoration: "none" }} className="headerLinkText" href="#">Contribution Management</Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="mr-auto headerLinkText">
                                    <Nav.Link className="headerLinkText" href="http://www.wespath.org" target="_blank" rel="noopener">wespath.org</Nav.Link>
                                    <Nav.Link className="headerLinkText" href="https://portal.wespath.org" target="_blank">Wespath Portal</Nav.Link>
                                    <Nav.Link className="headerLinkText" href="/contactus" target="_top">ContactUs</Nav.Link>
                                    <Nav.Link className="headerLinkText" onClick={() => props.logout()} target="_blank">Logout</Nav.Link>
                                </Nav>

                            </Navbar.Collapse>
                        </Navbar>
                    }
                    <div className="mr-1 pr-1 pl-0 mt-1 text-right">
                        <UserInstitutions />
                    </div>
                </Col>
            </Row>
        </>
    );

    const UserInstitutions = () => (<>
        {isLoggedOut
            ? <div style={{ height: "50px" }} />
            : <>
                <div>
                    {isLoading && <LoadingSkeleton />}
                    {!isLoading &&
                        <> <h5 className="smallLabel">{props.user?.domain + "\\" + props.user?.userName}, {getCurrentDate()}</h5> </>
                    }
                </div>
                {!isLoading && props.user?.institutions.length > 1
                    ? <div className="my-1"
                        style={{
                            display: "inline-block",
                            position: "relative",
                            border: "0px",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        <DropDown name="institution"
                            style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                opacity: "0",
                                cursor: "pointer"
                            }}
                            displayWithValue={true}
                            dropDownOptions={props.user?.institutions}
                            defaultValue={props.dcr?.selectedInstitution}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { onChangeInstitution(e); }}
                        />
                        <div className="text-nowrap" style={{ cursor: "pointer" }} id="selectedOptionHidden">
                            {selectedInstitutionText ? selectedInstitutionText : getSelectedInstitutionText(props.dcr?.selectedInstitution)}  <FontAwesomeIcon icon={faCaretDown} className="mr-1 ml-1" />
                        </div>
                    </div>
                    : <div className="text-nowrap my-1">
                        {selectedInstitutionText ? selectedInstitutionText : getSelectedInstitutionText(props.dcr?.selectedInstitution)}
                    </div>
                }
            </>
        }
    </>);



    return (
        <>
            <div className="gradientBackground w-100">

                <Container className="px-0" style={{ overflowX: "hidden", overflowY: "hidden" }}>
                    <div className="d-none d-lg-block">
                        <DesktopNavBar />
                    </div>
                    <div className="d-lg-none d-xl-none">
                        <MobileNavBar />
                    </div>
                </Container>
            </div>
            {!isLoggedOut &&
                <div className="px-xl-0 container px-0" style={{ overflowX: "hidden" }}>
                    <Row>
                        <Col>
                            <ul className="nav nav-tabs" role="tablist">
                                <li className="nav-item" role="presentation"><NavLink className={isManageContributionTabActive ? "nav-link active px-1 py-2 px-sm-3" : "nav-link px-1 py-2 px-sm-3"} to={Path.ContributionHistory}>Manage Contributions</NavLink></li>
                                <li className="nav-item" role="presentation"><NavLink className="nav-link px-1 pr-4 py-2 px-sm-3" to={Path.ManageAccounts}>Manage Account</NavLink></li>
                            </ul>
                        </Col>
                    </Row>
                </div>

            }
        </>
    )
};

function mapStateToProps(state: AppState) {

    return {
        dcr: state.dcr,
        user: state.dcr.currentuserInfo.user,
        cmSchedulePayment: state.cmSchedulePayment,
        history: state.cmHistory
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({ ...dcrActionCreators, ...historyActionCreators, ...helperActionCreators, ...accountActionCreators, resetSchedulePaymentState: schedulePaymentActionCreators.resetState }, dispatch);
}

const LoadingSkeleton = () => (
    <div>
        <div><Skeleton width={'8em'} height={'1em'} /></div>
        <div><Skeleton width={'10em'} height={'1.5em'} /></div>
    </div>
);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CMHeader);

